/**
 * Dependencies
 */
import {
    getProjectTemplates,
    createTemplateFromProject
} from '../../../../services/ProjectService'

/**
 * Create a template from an existing project
 *
 * @param  {Object} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
const createTemplate = ({ commit }, payload) => {
    commit('SET_PENDING')
    return createTemplateFromProject(payload)
        .then(res => {
            commit('TEMPLATE_CREATE_SUCCESS', res.data)
            return Promise.resolve(res.data)
        })
        .catch(err => {
            commit('TEMPLATE_CREATE_FAILURE', err)
            return Promise.reject(err)
        })
}

/**
 * Get the template list
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const getTemplates = ({ commit }) => {
    return getProjectTemplates()
        .then(res => {
            commit('TEMPLATES_GET_SUCCESS', res.data)
            return Promise.resolve(res.data)
        })
        .catch(err => {
            commit('TEMPLATES_GET_FAILURE', err)
            return Promise.reject(err)
        })
}

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const resetState = ({ commit }) => {
    commit('RESET_STATE')
}

export default {
    resetState,
    getTemplates,
    createTemplate
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/templates/actions.js